var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FilterSourceService from "../../../Services/FilterSource.service";
import FilterSourceColumnService from "../../../Services/FilterSourceColumn.service";
import useService from "../../Hooks/useService";
import Busy from "../../../../components/shared/busy";
const ReportSourceHelpContainer = (props) => {
    const [fetchFilterSourceState, fetchFilterSource] = useService(FilterSourceService.fetchFilterSource);
    const [fetchFilterSourceColumnsState, fetchFilterSourceColumns] = useService(FilterSourceColumnService.fetchFilterSourceColumnsForFilterSource);
    const fetchData = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        // See if we are editing an existing filter, or creating a new filter.
        // If editing, load the filter.
        if (props.match.params.sourceId) {
            fetchFilterSource(props.match.params.sourceId);
            fetchFilterSourceColumns(props.match.params.sourceId);
        }
    }), [
        fetchFilterSource,
        fetchFilterSourceColumns,
        props.match.params.sourceId,
    ]);
    React.useEffect(() => {
        fetchData();
    }, [fetchData]);
    // If loading, show the loading indicator.
    if (fetchFilterSourceState.isLoading) {
        return _jsx(Busy, { isBusy: true });
    }
    if (fetchFilterSourceState.hasError ||
        fetchFilterSourceColumnsState.hasError) {
        return (_jsx("div", { className: "alert alert-danger", children: "We're sorry, but there was an error loading this report source." }));
    }
    if (!fetchFilterSourceState.data) {
        return (_jsx("div", { className: "alert alert-info", children: "Unable to load report source." }));
    }
    const filterSource = fetchFilterSourceState.data;
    const filterSourceColumns = fetchFilterSourceColumnsState.data;
    return (_jsx("div", { children: _jsxs("div", { className: "container-fluid py-3", children: [_jsxs("div", { className: "mb-3", children: [_jsxs("h1", { children: [filterSource.displayName, " Report Fields"] }), _jsx("div", { className: "text-muted", children: filterSource.description })] }), !filterSourceColumns && (_jsx("div", { className: "fa fa-info", children: "This report source contains no columns." })), filterSourceColumns &&
                    filterSourceColumns
                        .filter((fsc) => fsc.filterSourceColumn.canSelect ||
                        fsc.filterSourceColumn.canFilter)
                        .map((fsc, index) => {
                        return (_jsxs("div", { className: "py-3", children: [_jsxs("h5", { children: [fsc.filterSourceRelationship &&
                                            `${fsc.filterSourceRelationship.title} - `, " ", fsc.filterSourceColumn.displayName] }), _jsx("div", { className: "text-muted my-1", children: fsc.filterSourceColumn.description }), _jsxs("div", { className: "form-group", children: [fsc.filterSourceColumn.canSelect && (_jsx("span", { className: "badge badge-secondary mr-2", children: "Selectable" })), fsc.filterSourceColumn.canFilter && (_jsx("span", { className: "badge badge-secondary mr-2", children: "Filterable" }))] })] }, index));
                    })] }) }));
};
export default ReportSourceHelpContainer;
